import React, { useState } from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import {
  CustomerSearchCriteria,
  PageListBean,
  PickTicketBean,
  RestCustomerListRequest,
  RestPageListBean,
  RestPickTicket_v1Request,
  RestReadRequest,
  RestSalesOrderListRequest,
  SalesOrderBean,
  SalesOrderSearchCriteria,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DatePickerComponent,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { PopupSalesModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { PickTicketService } from "../services/PickTicketService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import { ModuleUtils } from "./ModuleUtils.js";
class GeneratePickTicket extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Generate PickTicket",
      isShowExitButton: true,
      isShowExecuteButton: true,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      criteria: new SalesOrderSearchCriteria(),
      criteriaViewShow: false,
      dataListFound: false,
      isShowProgressBarPopup: false,
      salesOrderList: [],
      companyCode: " ",
      error_list: [],
      isShowProgressBarPopup: false,
      isShowSalesOrderMaintenanceModule: false,
      moduleForPopup: [],
      customerLookupHandler: null,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompletecustomerList: true,
      salesOrderData: new SalesOrderBean(),
      pickTicketBean: new PickTicketBean(),
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      order: "asc",
      isDisableFields: false,
      sortField: "",
    };
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    ModuleUtils.getSalesOrderStatusList();
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  execute = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadPage(1);
    this.hideAlertCallBack();
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.orderStatus = LogicConstants.SALES_ORDER_APPROVE_STATUS;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    pageInput.currentPage = pageNumber;
    let listRequest = new RestSalesOrderListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;
    this.loadGeneratePickTicketDetailList(listRequest);
  };
  loadGeneratePickTicketDetailList = (listRequest) => {
    if (SecurityAccessManager.MassGenaratePickTickets_IsAccessible()) {
      SalesOrderService.getSalesOrderPageList(
        listRequest,
        this.loadGeneratePickTicketResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess();
    }
  };
  loadGeneratePickTicketResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.salesOrderPageList != null) {
      let salesOrderList = new Array();
      if (!isEmptyArray(response.data.salesOrderPageList.salesOrders)) {
        salesOrderList = response.data.salesOrderPageList.salesOrders;
      }
      this.setState({
        dataListFound: true,
        isDisableFields: true,
        salesOrderList: salesOrderList,
        isShowClearCriteriaButton: false,
        isShowResetButton: true,
        isShowProgressBarPopup: false,
        progressLoadingText: " ",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({ isShowProgressBarPopup: false, progressLoadingText: "" });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerName = "";
      criteria.customerCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.loadCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  loadCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  loadCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.loadCustomerDetailResponse,
      this.errorCallBack
    );
  };
  loadCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.loadByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  loadByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.loadCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowSalesOrderMaintenanceModule: isOpen,
      moduleForPopup: [],
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewSalesOrderModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesOrderMaintenanceModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  generatingPickTicketReprot = (e, data) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Generating PickTicket...",
      });
      let request = new RestPickTicket_v1Request();
      request.companyCode = this.companyCode;
      request.salesOrderBean = data;
      request.code = data.code;
      request.isLockRequired = true;
      this.generatePickTicketDetails(request);
    }
  };
  generatePickTicketDetails = (request) => {
    if (SecurityAccessManager.MassGenaratePickTickets_IsAccessible()) {
      PickTicketService.generatePickTicketEntry(
        request,
        this.generatePickTicketResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess();
    }
  };
  generatePickTicketResponse = (response) => {
    let isSuccess = this.handleResponse(response.data);
    if (isSuccess) {
      if (
        response.data.pickTicket != null &&
        response.data.pickTicket != null
      ) {
        let pickTicket = response.data.pickTicket;
        this.setState({
          pickTicketBean: pickTicket,
        });
        this.GenerateReport(pickTicket);
      }
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  GenerateReport = (pickTicket) => {
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = pickTicket.code;
    if (SecurityAccessManager.MassGenaratePickTickets_IsAccessible()) {
      PickTicketService.printPickTicket(
        request,
        this.generateReportResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess();
    }
  };
  generateReportResponse = (response) => {
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  clearCriteria = () => {
    let criteria = new SalesOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = " ";
    this.setState({ criteria: criteria });
  };
  resetInquiry = () => {
    let criteria = new SalesOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = "";
    this.setState({
      criteria: criteria,
      dataListFound: false,
      salesOrderList: new Array(),
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let salesOrderList = this.state.salesOrderList;
    if (sortField && !isEmptyArray(salesOrderList)) {
      const sorted = [...salesOrderList].sort((a, b) => {
        if (isEmpty(a[sortField])) return 1;
        if (isEmpty(b[sortField])) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        if (a[sortField] === undefined && b[sortField] === undefined) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ salesOrderList: sorted });
    }
  };
  render() {
    let salesOrderList = this.state.salesOrderList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          execute={this.execute}
          reset={this.resetInquiry}
          clearCriteria={this.clearCriteria}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          customerCodeRef={this.customerCodeRef}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
        />
        {this.state.dataListFound && (
          <>
            <Row>
              <FormLabel className="table_title">Pickticket List</FormLabel>
            </Row>
            <div className="div_default">
              <Table id="fabrics_tables">
                <thead>
                  <th onClick={(e) => this.handleSortingChange(e, "code")}>
                    SalesOrder
                    {this.state.order === "desc" &&
                    this.state.sortField === "code" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "customerCode")}
                  >
                    Customer
                    {this.state.order === "desc" &&
                    this.state.sortField === "customerCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "customerName")}
                  >
                    CustomerName
                    {this.state.order === "desc" &&
                    this.state.sortField === "customerName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "orderStatus")}
                  >
                    Status
                    {this.state.order === "desc" &&
                    this.state.sortField === "orderStatus" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "customerPurchaseOrderNumber")
                    }
                  >
                    CustomerPo
                    {this.state.order === "desc" &&
                    this.state.sortField === "customerPurchaseOrderNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "paymentTermCode")
                    }
                  >
                    PaymentTerm
                    {this.state.order === "desc" &&
                    this.state.sortField === "paymentTermCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "shipViaCode")}
                  >
                    ShipVia
                    {this.state.order === "desc" &&
                    this.state.sortField === "shipViaCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "createdDate")}
                  >
                    CreatedDate
                    {this.state.order === "desc" &&
                    this.state.sortField === "createdDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "orderStopDate")
                    }
                  >
                    StopDate
                    {this.state.order === "desc" &&
                    this.state.sortField === "orderStopDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th>
                    Contact
                    {this.state.order === "desc" &&
                    this.state.sortField === "code" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th>
                    Phone
                    {this.state.order === "desc" &&
                    this.state.sortField === "code" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th> </th>
                </thead>
                <tbody>
                  {salesOrderList.map((data, index) => (
                    <tr key={index}>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewSalesOrderModule(e, data.code)
                          }
                        >
                          {data.code}
                        </Button>
                      </td>
                      <td>{data.customerCode}</td>
                      <td>{data.customerName}</td>
                      <td>
                        {ModuleUtils.getSalesOrderStatusCaption(
                          data.orderStatus
                        )}
                      </td>
                      <td>{data.customerPurchaseOrderNumber}</td>
                      <td>{data.paymentTermCode}</td>
                      <td> {data.shipViaCode} </td>
                      <td> {data.createdDate} </td>
                      <td> {data.orderStopDate} </td>
                      <td> {data.address.contactPerson}</td>
                      <td>{data.address.phone1}</td>
                      <td>
                        <Button
                          id="fabric_Add_Button"
                          sm="1"
                          onClick={(e) =>
                            this.generatingPickTicketReprot(e, data)
                          }
                        >
                          GeneratePickTicket
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {salesOrderList.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}

              <MultiViewPopup
                isModulePopup={true}
                id="modulePopup"
                popupLvlClass={"popupSizeLevel0"}
                isShowPopup={this.state.isShowSalesOrderMaintenanceModule}
                closeModalCallBack={this.closeModalCallBack}
                module={this.state.moduleForPopup}
              ></MultiViewPopup>
            </div>
          </>
        )}
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const onChange = (e) => props.onChange(e);
  let criteria = props.criteria;
  const customerCodeRef = props.customerCodeRef;
  let customerLookupHandler = props.customerLookupHandler;
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  return (
    <div>
      <Row className="d-flex justify-context-left">
        <Col sm="1">
          <FormLabel> Customer Code </FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="customerCode"
            ref={customerCodeRef}
            lookupRequired={true}
            value={criteria.customerCode}
            showCriteriaDialog={true}
            onChange={customerCodeOnChange}
            lookupHandler={customerLookupHandler}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteList}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel> OrderStopDate From </FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="orderStopDatefrom"
            onChange={onChange}
            value={criteria.orderStopDatefrom}
            disabled={props.isDisableFields}
          ></DatePickerComponent>
        </Col>
        <Col sm="1">
          <FormLabel> OrderStopDate To </FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="orderStopDateTo"
            onChange={onChange}
            value={criteria.orderStopDateTo}
            disabled={props.isDisableFields}
          ></DatePickerComponent>
        </Col>
      </Row>
    </div>
  );
}
function GeneratePickTicketModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <GeneratePickTicket {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default GeneratePickTicketModule;
